
export default class{

    constructor(options) {
        this.defaults = {
        	$el: false,
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'image-tooltips';

		this.$el = this.options.$el;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){

    	this.addEvents( true );
    }

    addEvents(b){
    	let $tooltips = this.$el.find('a.map-point');
    	if ( $tooltips.length > 0 ){
			if ( b ){
		        $tooltips.on( 'click', (e)=>{
		            e.preventDefault();
		        });
		        $tooltips.on( 'mouseenter', (e)=>{
		            //_this.timeout = setTimeout( function(){
		            	this.showTooltip( e, true )
		            //}, 600);
		        });
		        $tooltips.on( 'mouseleave', (e)=>{
		            this.showTooltip( e, false );
		        });
			}
			else{
		        $tooltips.off( 'click', (e)=>{
		            e.preventDefault();
		        });

		        $tooltips.off( 'mouseenter', (e)=>{
		            this.showTooltip( e, true );
		        });

		        $tooltips.off( 'mouseleave', (e)=>{
		            this.showTooltip( e, false );
		        });
			}
		}
    }

    showTooltip( e, b ){
        let $a = $(e.currentTarget), $map = $a.parents( '.overlay-map' ), $tooltip = $map.find( '.tooltip' ), x, y, w = $(window).width(), offset,
        margen = w<=768?10:10, margenTop = w<=768?0:0, tw;

        if ( b ){

        	offset = $map.offset();
            
            // $tooltip.find( '.text' ).html( $a.attr('data-index') + '. ' + $a.find( '.tip' ).html() );
            $tooltip.find( '.text' ).html( $a.find( '.tip' ).html() );

            tw = $tooltip.outerWidth();

            // 1) calculate POSITION
            x = $a.parent('.point').position().left; // - tw/2;
            y = $a.parent('.point').position().top - $tooltip.height() - 40;

            // 2) CHECK LIMITS
            // check left
            if ( x < (- offset.left + margen) ){
                x = - offset.left + margen;
            }
            // check right
            else if ( (offset.left + x + tw )  > (w - margen) ){
                x = w - offset.left - margen - tw;
            }
            // check top
            /*
            if ( y < margenTop ){
            	y = margenTop;
            }
            */

            // 3) Set POSITION
            $tooltip.css({
                top: y,
                left: x
            });

            $tooltip.addClass( 'active' )
        }
        else{

            $tooltip.removeClass( 'active' )
        }
    }


    destroy(){
    	this.addEvents( false );
    }

}